<template>
  <div class="home">
    <div class="job-category-top">
      <div class="blue-back">
        <div class="wrap blue-inner">
          <p class="job-category-title">Designer</p>
          <h1 class="job-category-sub">デザイナーの求人情報</h1>
        </div>
      </div>
      <div class="wrap">
        <img
          alt="デザイナートップ"
          src="@/assets/job-category/GH-kyujin-design001.webp"
          class="top"
        />
        <div class="text">
          <p>
            デザイナーのお仕事で、時間的な自由を求める人は、岐阜市にある株式会社グレイトヘルプの求人をぜひチェックしてみてください。<br />弊社は、ウェブや紙面のデザイナーとして、家事や子育てに忙しい主婦・主夫、フリーランス・個人事業主としてご自身のお仕事をしながら勤務される方が主となって活躍する職場です。<br />出勤曜日が自由、勤務時間が自由、無駄な拘束時間なしなど、仕事において時間的な制約がある人が働きやすい勤務条件と職場環境を整えています。
          </p>
          <img src="@/assets/ezgif.com-gif-maker-A.png" alt="説明イラスト" />
        </div>
        <img
          src="@/assets/ezgif.com-gif-maker-B.png"
          alt="雲"
          class="illust-b"
        />
      </div>
    </div>

    <div class="recommendation">
      <HomeRecommendation />
    </div>

    <div class="space-top-70 space-top-130">
      <HomeWorkPlace />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment />
    </div>

    <div class="space-top-130">
      <HomeWorkEnvironment2 />
    </div>

    <div class="space-top-130">
      <JobCategoryAboutWork
        :topImg="true"
        :middleImg="true"
        :imgPath1="'GH-kyujin-design002.webp'"
        :imgPath2="'GH-kyujin-design003.webp'"
        :subTitle="'デザイナーのお仕事について'"
        :detail="'弊社のデザイン業務は主に、ウェブ系は、ホームページ、ネットショップ、広告用のバナーなどのデザイン業務。紙媒体系は、チラシ、名刺、封筒、ロゴなどのデザイン業務があります。他にも、撮影の立会や補助、紙媒体の印刷業務もあります。クライアントから媒体と販促物の制作業務のすべてを請け負っているケースが多いため、このようにありとあらゆるデザインとそれに関する業務を担当していただきます（保有するスキルと経験を考慮して業務を割り当てるため、全スキルを保有していなくても問題ありません）。<br />ホームページやネットショップなど、ウェブ系のデザインは、イラストレーターでその外観をデザインしていただくお仕事になりますので、コーディングやプログラミングのスキルは不問です。<br />基本的に、マーケティング部門が考案した指示書・原案に基づいてデザインをしていただくお仕事になります。クライアントとの打ち合わせ業務は基本的にはありませんし、打ち合わせを通して、クライアントにデザインを提案するお仕事でもありません。事務所でパソコンに向かって、デザインをしていただくお仕事です。<br />弊社は、デザインをウリにした会社ではなく、マーケティングをウリにした会社です。そのため、クライアントからデザインのことで厳しく指摘を受けて、何度も何度も修正対応が発生する、というような仕事は滅多にありません。このような対応をしても、マーケティングが改善されるわけではないため、そのようなお仕事はお断りしています。'"
        :skill="'IllustratorとPhotoshopを使用したデザインスキルと実務経験は必須です。紙媒体の印刷に関するスキルや経験もあると良いです。<br />ホームページやネットショップなど、ウェブ系のデザインについては、コーディングのスキルは不問です。その外観をデザインしていただきます。また、ウェブ媒体で再現できるデザインをする必要があるため、この論理やルールについては、入社後に教育します。<br />弊社は、デザイン会社ではなく、マーケティング会社です。そのため、こちらからデザインを提案したり、クライアントのブランディングを提案したりというような、デザインに対する提案力や独創性が求められるお仕事は多くはありません。<br />クライアントは、売上アップやマーケティング強化を目的に、弊社にお仕事をご依頼いただくケースが多いため、マーケティングを考慮したデザインをしていただくことになります。<br />具体的には、クライアントから明確なデザインの希望があり、その希望どおりにデザインをする。マーケティング部門がマーケティングを考慮したデザインイメージを提示し、そのイメージに基づいてデザインをする。このように、指示に対して忠実なデザインをするスタンスとスキルが必要となります。言い換えるならば、「マーケティングを犠牲にしないデザイン」が求められます。<br />そのため、「自分がしたいデザインを自由にできる」というお仕事ではありません。「自分が創造するものを形する、デザインすることだ」というスタンスで、指示にそったデザインができない人は、弊社のお仕事は向きません。業務対応への柔軟性があるデザイナーに向くお仕事です。'"
        :experience="'弊社はウェブマーケティングに強みがあり、制作する媒体を通して事業主様の売上アップや集客増などの業績向上を支援しています。そのため、弊社でデザインの業務を経験することで、ただデザインするだけでなく、売上アップや集客増などのマーケティングを考慮したデザインのスキルが身につきます。<br />また、仕事の多くは、ホームページやネットショップなどのウェブ媒体のデザインとなります。そのため、ウェブで再現できるデザインの技法が身につきます。'"
      />
    </div>

    <div class="space-top-130 space-top-70">
      <JobCategoryInfo
        :job="'デザイナー'"
        :content="'Illustrator・Photoshopによるホームページやチラシなどのデザイン業務など'"
        :condition="'デザインの実務経験3年以上'"
        :pay="'1,100円～1,500円<br>※「長期間、勤務していただきたい」という思いから、スタートの時給は1,100円で、勤務評価と勤務年数によって時給が上がる評価制度をとっています。'"
        :raise="'20円〜100円/時（社内の全職種による実績）'"
        :pg="false"
        :wdn="false"
        :isNonInsurableEmployment="true"
        :isStopRecruitment="true"
      />
    </div>
    <div class="space-top-130 space-top-70">
      <HomeSelectionSchedule />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeQa :qaBoxList="qaBoxList" />
    </div>

    <div class="space-top-130 space-top-70">
      <HomeContact id="contact" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeRecommendation from "@/components/Home/Recommendation.vue";
import HomeWorkPlace from "@/components/Home/WorkPlace.vue";
import HomeWorkEnvironment from "@/components/Home/WorkEnvironment.vue";
import HomeWorkEnvironment2 from "@/components/Home/WorkEnvironment2.vue";
import JobCategoryAboutWork from "@/components/JobCategory/AboutWork.vue";
import JobCategoryInfo from "@/components/JobCategory/Info.vue";

import HomeSelectionSchedule from "@/components/Home/SelectionSchedule.vue";
import HomeQa from "@/components/Home/Qa.vue";
import HomeContact from "@/components/Home/Contact.vue";

export default {
  name: "Home",
  components: {
    HomeRecommendation,
    HomeWorkPlace,
    HomeWorkEnvironment,
    HomeWorkEnvironment2,
    JobCategoryAboutWork,
    JobCategoryInfo,
    HomeSelectionSchedule,
    HomeQa,
    HomeContact,
  },
  props: {},
  data() {
    return {
      qaBoxList: [
                {
          id: 1,
          qestion: "自由出勤の仕組みについて教えてください。自由に休めますか？",
          answer:
            "他の従業員と業務の進捗への影響がないことを前提にした勤務時間の自由となります。入社時に、1週間あたりの勤務時間（週15時間～）を決定します。この勤務時間において、出勤曜日と勤務時間が自由という仕組みです。出勤予定日にお休みをとった場合は、原則として1週間以内に欠勤分の勤務時間を補填する勤務をしていただいています（欠勤の理由と業務状況によっては補填なしの場合もあり）。お子様の長期休暇時は、事前の申請と調整によって、勤務日数・勤務時間を通常よりも減らすことは可能です。この条件を満たせる方のみご応募可能となっています。",
        },
        {
          id: 2,
          qestion: "ウェブのスキルは必要となりますか？",
          answer:
            "必要ありません。IllustratorとPhotoshopで、ウェブ媒体の外観をデザインしていただくお仕事になります。ウェブデザインの論理やルールは入社後に教育します。",
        },
        {
          id: 3,
          qestion: "どの程度のデザインスキルが必要となりますか？",
          answer:
            "IllustratorとPhotoshopの操作スキルとその実務経験3年以上は必須です。職業訓練校、学校、独学、趣味などでのデザインの経験は実務経験とみなしません。",
        },
        {
          id: 4,
          qestion: "使用する端末のOSは何でしょうか？",
          answer: "WindowsまたはMacでご希望の方の端末をご用意します。",
        },
        {
          id: 5,
          qestion: "副業・フリーランスでの応募も可能でしょうか？",
          answer:
            "平日9時30分～17時のご希望の曜日・時間帯で週15時間以上の勤務ができる場合は応募可能です。",
        },
        {
          id: 6,
          qestion: "在宅勤務・テレワークは可能でしょうか？",
          answer:
            "事務所への出社での勤務となっています。緊急事態宣言時などのみ行う場合があり、在宅勤務は原則としてございません。在宅勤務やテレワークをご希望の場合は、外注としてのお取引が可能な場合がありますので、詳細はお問い合わせをお願いします。",
        },
        {
          id: 7,
          qestion: "グレイトヘルプに勤務しながら、副業は可能でしょうか？",
          answer:
            "可能です。ただし、弊社での勤務がメインであることを前提とします。また、弊社の事業内容と競合する仕事などは制限がある場合がございます。",
        },
        {
          id: 8,
          qestion: "業務中に車を運転することはありますか？",
          answer:
            "職種によってはあります。頻度はまれです。社有車があります。ご自身のお車を使う場合は手当を支給しています。業務中にお車の運転ができないことを前提とした応募も可能ですので、応募書類にその旨をご記載ください。",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
  watch: {},
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.job-category-top {
  .blue-back {
    background-color: var(--main);
    .blue-inner {
      position: relative;
      padding-top: 100px;
      padding-bottom: 150px;
      @media screen and (max-width: 767px) {
        margin-top: 70px;
      }
      h1,
      p {
        color: white;
      }
    }
  }
  .top {
    margin-top: -120px;
  }
  .text {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 30px;
    @media screen and (max-width: 767px) {
      display: block;
    }
    p {
      width: 80%;
      margin-bottom: 30px;
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    img {
      width: 250px;
      @media screen and (max-width: 767px) {
        width: 200px;
        margin-left: calc(100% - 200px);
      }
    }
  }
  .illust-b {
    width: 200px;
    position: absolute;
    top: 60%;
    left: 15%;
    @media screen and (max-width: 1024px) {
      display: none;
    }
  }
}
.about-us {
  display: flex;
  justify-content: space-between;
  padding-bottom: 50px;
  position: relative;
  .left {
    width: 20%;
    h1 {
      margin-bottom: 30px;
    }
    p {
      color: var(--main);
    }
  }
  .right {
    width: 70%;
  }
  .illust-a {
    width: 200px;
    position: absolute;
    bottom: 0;
    left: calc(20% - 100px);
  }
  .illust-b {
    width: 200px;
    position: absolute;
    top: -15%;
    left: -13%;
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      display: none;
    }
    @media screen and (max-width: 767px) {
      top: 105%;
      left: 45%;
    }
  }
}
.recommendation {
  background-color: var(--sub);
}
</style>